import { render } from "./TpWalletImport.vue?vue&type=template&id=7beeab20&scoped=true"
import script from "./TpWalletImport.vue?vue&type=script&lang=js"
export * from "./TpWalletImport.vue?vue&type=script&lang=js"

import "./TpWalletImport.vue?vue&type=style&index=0&id=7beeab20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7beeab20"]])

export default __exports__